import React, { useState } from "react";
import CustomSelectInput from "../../../../components/CustomSelectInput/CustomSelectInput";
import { Checkbox, FormControlLabel } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import styles from '../CommonStyles/commonformstyles.module.scss'
import "./experienceform.scss";
import { useNavigate } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import Cookie from 'js-cookie';
import { useAddExperience } from "../../../../hooks/partnerHook/usePartnerExperience";
import { useSelector } from "react-redux";

function ExperienceForm() {
    const navigate = useNavigate();
    const userData = useSelector((state) => state.partner.user);
    const partnerId = userData?.partner?.id;
    const [formData, setFormData] = useState({
        title: "",
        employmentType: "",
        company: "",
        location: "",
        description: "",
        startDate: null,
        endDate: null,
        isWorking: false,
        locationType: "",
    });

    const [formErrors, setFormErrors] = useState({});

    const keywordsList = [
        { key: 1, type: "Full Time" },
        { key: 2, type: "Permanent" },
        { key: 3, type: "Fresher" },
        { key: 4, type: "Part-Time" },
        { key: 5, type: "Internship" },
        { key: 6, type: "Temporary" },
        { key: 7, type: "Freelance" },
        { key: 8, type: "Volunteer" },
        { key: 9, type: "Co-Pilot" },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleKeywordClick = (keyword) => {
        setFormData((prevData) => ({ ...prevData, employmentType: keyword }))
    };

    const handleBackspace = (e) => {
        setFormData((prevData) => ({ ...prevData, employmentType: '' }))
    };
    const { mutate: addExperience, isError, isPending } = useAddExperience(navigate)

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = {};

        if (!formData.title) errors.title = "Please enter the title";
        if (formData.employmentType.length === 0)
            errors.employmentType = "Please select at least one keyword";
        if (!formData.company)
            errors.company = "Please enter the company name";
        if (!formData.location) errors.location = "Please enter the location";
        if (!formData.description)
            errors.description = "Please enter the description";
        if (!formData.startDate) errors.startDate = "Please select the start date";
        if (!formData.isWorking && !formData.endDate)
            errors.endDate = "Please select the end date";

        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            console.log("Form submitted", formData);
            await addExperience({ partnerId, experienceData: formData })
            // navigate(-1, { replace: true });
        }
    };

    return (
        <>
            <div className={`experience-form ${styles.formContainer}`}>
                <h1 className={styles.formPageHeading}>Enter Your Professional Info</h1>
                <p className={styles.formpageSubHeading}>
                    This is your time to shine. Let potential buyers know what you do best
                    and how you gained your skills, certifications, and experience.
                </p>
                <h2 className={styles.formHeading}>Add Experience</h2>
                <form onSubmit={handleSubmit} className="professional-info-form">
                    {/* Title */}
                    <div
                        className={`input-field-cont ${formErrors.title ? "error-field" : ""}`} >
                        <label htmlFor="title" className={styles.inputLabel}>Title</label>
                        <div className="input-field">
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                placeholder="Ex. Agriculture drone pilot for spraying"
                            />
                            {formErrors.title && <p className="error">{formErrors.title}</p>}
                        </div>
                    </div>

                    {/* Employment Type */}
                    <div
                        className={`input-field-cont ${formErrors.employmentType ? "error-field" : ""
                            }`}
                    >
                        <label className={styles.inputLabel} htmlFor="employmentType">Employment Type</label>
                        <div className="input-field">
                            <input
                                type="text"
                                name="employmentType"
                                value={formData.employmentType}
                                onKeyDown={handleBackspace}
                                readOnly
                                placeholder="Ex. Full Time, Select Keyword"
                            />
                            {/* Keywords */}
                            <div className="keywords">
                                <div className="keyword-text">Select one keyword:</div>
                                <div className="keywords-cont">
                                    {keywordsList.map((keyword) => (
                                        <div
                                            key={keyword.key}
                                            className={`keyword-data ${formData.employmentType.includes(keyword.type)
                                                ? "selected"
                                                : ""
                                                }`}
                                            onClick={() => handleKeywordClick(keyword.type)}
                                        >
                                            {keyword.type}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {formErrors.employmentType && (
                                <p className="error">{formErrors.employmentType}</p>
                            )}
                        </div>
                    </div>

                    {/* Company Name */}
                    <div
                        className={`input-field-cont ${formErrors.company ? "error-field" : ""
                            }`}
                    >
                        <label className={styles.inputLabel} htmlFor="company">Company Name</label>
                        <div className="input-field">
                            <input
                                type="text"
                                name="company"
                                value={formData.company}
                                onChange={handleInputChange}
                                placeholder="Enter the company name"
                            />
                            {formErrors.company && (
                                <p className="error">{formErrors.company}</p>
                            )}
                        </div>
                    </div>

                    {/* Location */}
                    <div
                        className={`input-field-cont ${formErrors.location ? "error-field" : ""
                            }`}
                    >
                        <label className={styles.inputLabel} htmlFor="location">Location</label>
                        <div className="input-field">
                            <input
                                type="text"
                                name="location"
                                value={formData.location}
                                onChange={handleInputChange}
                                placeholder="Enter the location"
                            />
                            {formErrors.location && (
                                <p className="error">{formErrors.location}</p>
                            )}
                        </div>
                    </div>

                    {/* Location Type */}
                    <div
                        className={`input-field-cont ${formErrors.locationType ? "error-field" : ""
                            }`}
                    >
                        <label className={styles.inputLabel} htmlFor="locationType">Location Type</label>
                        <div className="input-field">
                            <CustomSelectInput
                                title={"On-Site, Off-Site, or Hybrid"}
                                data={["OnSite", "Off-Site", "Hybrid"]}
                                onSelect={(selected) =>
                                    setFormData({ ...formData, locationType: selected })
                                }
                            />
                            {formErrors.locationType && (
                                <p className="error">{formErrors.locationType}</p>
                            )}
                        </div>
                    </div>

                    {/* Description */}
                    <div
                        className={`input-field-cont ${formErrors.description ? "error-field" : ""
                            }`}
                    >
                        <label className={styles.inputLabel} htmlFor="description">Description</label>
                        <div className="input-field">
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                placeholder="Describe your experience"
                            />
                            {formErrors.description && (
                                <p className="error">{formErrors.description}</p>
                            )}
                        </div>
                    </div>

                    {/* Dates Details */}
                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
                    <div className="date-field">
                        {/* Start Date */}
                        <div className="date-cont">
                            <h3>Start Date*</h3>
                            {/* <DatePicker
                                    className="date-picker"
                                    value={formData.startDate}
                                    onChange={(date) =>
                                        setFormData({ ...formData, startDate: date })
                                    }
                                /> */}
                            <input type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} id="" />
                            {formErrors.startDate && (
                                <p className="error">{formErrors.startDate}</p>
                            )}
                        </div>

                        {/* End Date */}
                        <div className="date-cont">
                            <h3>End Date*</h3>
                            {/* <DatePicker
                                    className="date-picker"
                                    value={formData.endDate}
                                    disabled={formData.isWorking}
                                    onChange={(date) => setFormData({ ...formData, endDate: date })}
                                /> */}
                            <input type="date" name="endDate" value={formData.endDate} disabled={formData.isWorking} onChange={handleInputChange} id="" />
                            {formErrors.endDate && (
                                <p className="error">{formErrors.endDate}</p>
                            )}
                        </div>
                    </div>

                    {/* Checkbox for Currently Working */}
                    <div className="currently-working">

                    <input style={{outline: 'none'}} checked={formData.isWorking} type="checkbox" name="isWorking" id=""
                        onChange={() =>
                            setFormData({ ...formData, isWorking: !formData.isWorking })
                        } />
                    <label htmlFor="">I'm currently working in this role</label>

                    </div>
                    <div className="btn-container">
                        <Button
                            label={'Save Details'}
                            type='submit'
                            customStyle={{
                                backgroundColor: 'green',
                                color: 'white',
                                border: 'none'
                            }}
                        />
                    </div>
                </form>
            </div>
        </>
    );
}

export default ExperienceForm;
